import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const recommendationItemSchema = z.object({
  keyword: z.string().trim(),
});
export type RecommendationItem = z.infer<typeof recommendationItemSchema>;

const recommendationsResponseSchema = z.object({
  recommendations: z.array(recommendationItemSchema),
});

export const recommendApiDefinitions = prefixApi(
  "/merchandise",
  apiBuilder({
    alias: "getKeywordRecommendations",
    method: "get",
    path: "/recommend_keywords",
    parameters: [
      { name: "marketplace", type: "Query", schema: z.string().default("USA") },
      { name: "maxNumSuggestions", type: "Query", schema: z.coerce.number().default(100) },
      { name: "productIds", type: "Query", schema: z.string().array() },
    ],
    status: 200,
    response: recommendationsResponseSchema,
  }).build(),
);
